export const trimHash = (hash: string) => `${hash.substring(0, 4)}...${hash.substring(hash.length - 4)}`;

export function toHex(byteArray: Uint8Array) {
  return Array.from(byteArray, function (byte) {
    return ("0" + (byte & 0xff).toString(16)).slice(-2);
  }).join("");
}
